/** API route map: URLS.Controller.JobStatus */
export const JobStatus = {
      Name: 'JobStatus/',
      GetJobStatus: 'get-job-status',
      AddJobStatus: 'add-job-status',
      UpdateJobStatus: 'update-job-status',
      DeleteJobStatus: 'delete-job-status',
      UpdateJobStatusList: 'update-job-status-list',
      GetJobStatusByName: 'get-job-status-by-name',
};
